import jwt_decode from "jwt-decode";

/**
 * Décode un token JWT de manière sécurisée
 * @param {string} token - Le token JWT à décoder
 * @returns {object|null} - Les données décodées ou null en cas d'erreur
 */
export const safeJwtDecode = (token) => {
    try {
        if (!token || typeof token !== 'string' || token.trim() === '') {
            console.error('Token invalide ou vide');
            // Nettoyer le localStorage si le token est invalide
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('old_refresh_token');
            localStorage.removeItem('persist');
            return null;
        }
        return jwt_decode(token);
    } catch (error) {
        console.error('Erreur lors du décodage du token:', error);
        // Nettoyer le localStorage en cas d'erreur
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('old_refresh_token');
        localStorage.removeItem('persist');
        return null;
    }
};

/**
 * Vérifie si un token est expiré
 * @param {string} token - Le token JWT à vérifier
 * @returns {boolean} - true si le token est expiré, false sinon
 */
export const isTokenExpired = (token) => {
    const decoded = safeJwtDecode(token);
    if (!decoded || !decoded.exp) {
        return true;
    }
    const currentTime = Date.now() / 1000;
    return decoded.exp < currentTime;
};

